import { t } from 'i18next';
import { authClient } from '@/lib/auth';

export const useSession = () => {
  const { resetPassword, emailOtp, sendVerificationEmail, requestPasswordReset, useSession, signOut, signIn, signUp } =
    authClient;
  const session = useSession();
  const isAuthenticated = Boolean(session.data);
  const userData = session.data?.user;

  return {
    emailOtp,
    resetPassword,
    sendVerificationEmail,
    requestPasswordReset,
    isAuthenticated,
    userData,
    session,
    signOut,
    signIn,
    signUp,
  };
};

type CustomErrors = 'USER_ALREADY_EXISTS_USE_ANOTHER_EMAIL' | 'GOOGLE_ACCOUNT_ONLY' | 'FACEBOOK_ACCOUNT_ONLY';
type ErrorTypes = Partial<Record<keyof typeof authClient.$ERROR_CODES | CustomErrors, { pt: string }>>;

const errorCodes: ErrorTypes = {
  INVALID_EMAIL_OR_PASSWORD: {
    pt: t('user-not-found-description'),
  },
  USER_ALREADY_EXISTS_USE_ANOTHER_EMAIL: {
    pt: t('user-already-exists'),
  },
  EMAIL_NOT_VERIFIED: {
    pt: t('email-not-verified'),
  },
  INVALID_PASSWORD: {
    pt: t('invalid-email-or-password'),
  },
  INVALID_EMAIL: {
    pt: t('invalid-email-or-password'),
  },
  USER_NOT_FOUND: {
    pt: t('user-not-found'),
  },
  GOOGLE_ACCOUNT_ONLY: {
    pt: 'Ops! Parece que algo não deu certo. Esta conta foi criada usando Entrar com o Google. Faça login com sua conta Google para continuar.',
  },
  FACEBOOK_ACCOUNT_ONLY: {
    pt: 'Ops! Parece que algo não deu certo. Esta conta foi criada usando Entrar com o Facebook. Faça login com sua conta Facebook para continuar.',
  },
};

type ErrorCodeKeys = keyof typeof errorCodes;

export const getAuthErrorMessage = (code: string) => {
  const error = errorCodes[code as ErrorCodeKeys];
  return error?.pt ?? '';
};
